import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';
import { MutedOverlay, presetAttributes } from '../../../../interfaces';

@Component({
  tag: 'zeudy-muted-overlay',
  styleUrl: 'zeudy-muted-overlay.css',
  shadow: false,
})
export class zeudyMutedOverlay {
  @Prop() mutedPreview: boolean;
  @Prop() mutedOverlay: MutedOverlay;
  @Prop() preset: presetAttributes;

  @Event() playVideo: EventEmitter<void>;

  render() {
    return (
      <div
        class="zeudy-player__muted-overlay"
        onClick={() => {
          this.mutedPreview = false;
          this.playVideo.emit();
        }}
      >
        {this.preset?.['play-large'] && (
          <div class="plyr__control plyr__control--overlaid" data-plyr="play" aria-label="Play" part="muted-overlay-play">
            <svg id="plyr-play" viewBox="0 0 18 18">
              <path d="M15.562 8.1L3.87.225c-.818-.562-1.87 0-1.87.9v15.75c0 .9 1.052 1.462 1.87.9L15.563 9.9c.584-.45.584-1.35 0-1.8z"></path>
            </svg>
            <span class="plyr__sr-only">Play</span>
          </div>
        )}

        {this.mutedOverlay?.enabled && this.mutedOverlay?.src ? (
          <div
            class="zeudy-player__overlay is-image"
            part="muted-overlay-image"
            style={{
              width: `${this.mutedOverlay?.width || 50}%`,
              left: `${(this.mutedOverlay?.focalPoint?.x || 0.5) * 100}%`,
              top: `${(this.mutedOverlay?.focalPoint?.y || 0.5) * 100}%`,
            }}
          >
            <img src={this.mutedOverlay?.src} style={{ transform: 'translateX(-50%) translateY(-50%)' }} />
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}
